import React from 'react';

export default function FwMasksIcon({ color = 'currentColor', fontSize = '16px' }) {
  return (
    <>
      <i className='fas fa-theater-masks' style={{ color, fontSize: fontSize }}></i>
    </>
  );
}
